import {
  InvestigationTypeOfLossEnum,
  InvestigationWithAffectedBodyPartsSentence,
} from '@EHSNavigator/backend';
import * as Yup from 'yup';

export const getResubmitToOshaReportSchema = (
  step: number,
  filterOutReports: InvestigationWithAffectedBodyPartsSentence[] = [],
) => {
  const deaths =
    filterOutReports?.filter(
      (node) => node?.typeOfLoss === InvestigationTypeOfLossEnum.Death,
    )?.length || 0;

  const awayFromWorkCases =
    filterOutReports?.filter(
      (node) =>
        node?.typeOfLoss === InvestigationTypeOfLossEnum.DaysAwayFromWork,
    )?.length || 0;

  const jobTransferCases =
    filterOutReports?.filter(
      (node) =>
        node?.typeOfLoss ===
        InvestigationTypeOfLossEnum.RestrictedWorkActivityOrJobTransfer,
    )?.length || 0;

  const otherCasesRecordable =
    (filterOutReports?.length || 0) -
    deaths -
    awayFromWorkCases -
    jobTransferCases;

  const totalCases =
    deaths + awayFromWorkCases + jobTransferCases + otherCasesRecordable;

  if (step === 1) {
    return Yup.object();
  } else if (step === 2) {
    return Yup.object();
  } else if (step === 3) {
    return Yup.object().shape({
      annualAverageNumberOfEmployees: Yup.number()
        .typeError('Average Number of Employees must be a number')
        .required('Average Number of Employees is required')
        .test('greater-than-total-cases', function (value) {
          if (isNaN(value) || value === 0 || isNaN(value)) {
            return true;
          }
          if (value <= totalCases) {
            return this.createError({
              message: `Annual average employees (${value}) must be greater than total cases (${totalCases})`,
            });
          }
          return true;
        }),
      annualAverageNumberOfEmployeesWorkingHours: Yup.string()
        .required('Annual Employees Working Hours is required')
        .test('valid-working-hours', function (value) {
          const { annualAverageNumberOfEmployees } = this.parent;
          const employees = Number(annualAverageNumberOfEmployees);
          const hours = Number(value);
          if (isNaN(employees) || employees === 0 || isNaN(hours)) {
            // If not a number or zero, let required validation handle it
            return true;
          }
          const ratio = hours / employees;
          const min = 500;
          const max = 8760;
          const minTotal = Math.ceil(employees * min);
          const maxTotal = Math.floor(employees * max);

          if (ratio <= min) {
            return this.createError({
              message: `Total hours must be > ${minTotal} (for ${employees} employees, > ${min} hrs/employee)`,
            });
          }
          if (ratio >= max) {
            return this.createError({
              message: `Total hours must be < ${maxTotal} (for ${employees} employees, < ${max} hrs/employee)`,
            });
          }
          return true;
        }),
      reason: Yup.string().required('reason is required'),
    });
  } else {
    return Yup.object();
  }
};
